/* eslint-disable no-useless-escape */
export const phoneRegExp = '^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{2}[0-9]{4}';
export const phoneRegExpWithSpaces =
  '^\\([2-9]{1}[0-9]{2}\\) [2-9]{1}[0-9]{2} [0-9]{4}';
export const emailRegExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
